<settings-page-layout>
  @if (!actionCreated && loading$ | async) {
    <div>
      <div class="loading-section">
        <div class="margin-auto">
          <app-main-loader-lottie></app-main-loader-lottie>
        </div>
      </div>
    </div>
  } @else {
    <div class="checkout_settings">
      <div class="container">
        @if (appRequirements?.updateRequired) {
          <pdq-banner
            style="margin: 0 0 16px 0"
            variant="attention"
            [closable]="false"
            bannerTitle="Update app required"
            [content]="appRequirementsList"
            button="Update app"
            (onButtonClick)="onUpdateApp()">
          </pdq-banner>
        }
        @if (!(settings$ | async)?.scriptTagEnabled) {
          <pdq-banner
            style="margin: 0 0 16px 0"
            variant="attention"
            bannerTitle="Reminder: set up the PDQ Analytics Extension in Shopify"
            [content]="'To use advanced price settings in PDQ Checkout, either enable the PDQ script tag or configure the PDQ Analytics Extension.'">
          </pdq-banner>
        }
        <div class="header">
          <pdq-heading element="h3">Checkout settings</pdq-heading>
          <pdq-divider></pdq-divider>
          <pdq-heading element="h6" class="header__secondary"
            >Set up how shipping options appear in checkout</pdq-heading
          >
        </div>
        <div class="content">
          <checkout-test-mode [settings]="settings$ | async" [formGroup]="formGroup"></checkout-test-mode>
          @if ((shop$ | async)?.metadata?.useNewCheckout) {
            <connect-delivery-customization-function
              [requirements]="appRequirements"
              [settings]="settings$ | async"
              [formGroup]="formGroup"></connect-delivery-customization-function>
          }
          @if ((shop$ | async)?.platform === 'shopify') {
            <checkout-script-preferences
              [shop]="shop$ | async"
              [settings]="settings$ | async"
              [formGroup]="formGroup"></checkout-script-preferences>
          }
          @if ((shop$ | async)?.platform === 'shopify') {
            <price-preferences
              [shop]="shop$ | async"
              [settings]="settings$ | async"
              [formGroup]="formGroup"></price-preferences>
          }
          @if ((shop$ | async)?.platform === 'shopify') {
            <checkout-add-discount
              [formGroup]="formGroup"
              [settings]="settings$ | async"
              [shippings]="shippings$ | async">
            </checkout-add-discount>
          }
          @if ((shop$ | async)?.platform === 'shopify') {
            <plugins-script-preferences [shop]="shop$ | async" [settings]="settings$ | async" [formGroup]="formGroup">
            </plugins-script-preferences>
          }
          <checkout-process-time
            [shippings]="shippings$ | async"
            [checkoutSettings]="settings$ | async"></checkout-process-time>
          @if (!newAbTestingAndCheckoutIsEnabled) {
            <checkout-optimization [formGroup]="formGroup"></checkout-optimization>
          }
          @if (!newAbTestingAndCheckoutIsEnabled) {
            <checkout-abtest-global-settings [formGroup]="formGroup"></checkout-abtest-global-settings>
          }
          @if ((shop$ | async)?.platform === 'shopify') {
            <checkout-prioritization [shop]="shop$ | async" [settings]="settings$ | async" [formGroup]="formGroup">
            </checkout-prioritization>
          }
        </div>
        <footer class="save-footer" [ngClass]="formGroup.dirty && changesCounter > 0 ? 'apear' : 'initial'">
          <span>You have {{ changesCounter }} unsaved settings</span>
          <pdq-button variant="secondary" label="cancel" class="action-btn" (onClick)="onCancel()"></pdq-button>
          <pdq-button
            variant="primary"
            type="submit"
            label="save"
            class="action-btn"
            [loading]="loading$ | async"
            (onClick)="onSave()">
          </pdq-button>
        </footer>
      </div>
    </div>
  }
</settings-page-layout>
